<template>
  <div>
    <van-nav-bar
      title="充值"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    >
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>
    <van-popup
      v-model="showAlipayInfo"
      :style="{ width: '70%', padding: '8%' }"
      style="max-height: 300px"
    >
      <div>
        <van-row style="padding-top: 5px"
          ><van-col span="8"><span>&nbsp;</span></van-col>
          <van-col span="8" style="margin-top: -20px; text-align: center">
            <span class="bankDetails">充值通道</span></van-col
          >
          <van-col span="8" style="text-align: right; color: #d02e27">
            <span>&nbsp;</span></van-col
          >
        </van-row>
        <van-row style="padding-top: 5px"
          ><van-col span="10"
            ><span class="bankDetails"><strong>支付宝账号:</strong></span></van-col
          >
          <van-col span="10"
            ><span class="bankDetails" style="word-break: break-all">{{
              alipayInfo.alipay_account
            }}</span></van-col
          >
          <van-col span="4" style="text-align: right; color: #d02e27">
            <span class="bankDetails" @click="handleCopy(alipayInfo.alipay_account)"
              >复制</span
            ></van-col
          >
        </van-row>

        <van-row style="padding-top: 5px"
          ><van-col span="10"
            ><span class="bankDetails"><strong>支付宝姓名:</strong></span></van-col
          >
          <van-col span="10"
            ><span class="bankDetails" style="word-break: break-all">{{
              alipayInfo.alipay_name
            }}</span></van-col
          >
          <van-col span="4" style="text-align: right; color: #d02e27">
            <span class="bankDetails" @click="handleCopy(alipayInfo.alipay_name)"
              >复制</span
            ></van-col
          >
        </van-row>
        <van-row style="padding-top: 10px">
          <div>
            <img :src="alipayInfo.aiipay_qrcode" style="width: 100%" />
          </div>
        </van-row>
      </div>
      <van-row>
        <div style="padding-top: 12px">
          <van-button
            type="info"
            size="small"
            @click="closeAlipayPopup"
            plain
            style="
              width: 40%;
              /* margin-left: 5%; */
              margin-bottom: 5%;
              border-radius: 15px;
              background-color: #f0f0f0;
              color: #0d268d;
              border-color: #f0f0f0;
            "
            >取消
          </van-button>

          <van-button
            type="info"
            size="small"
            @click="submitAlipayPopup"
            plain
            style="
              width: 40%;
              margin-left: 16%;
              margin-bottom: 5%;
              border-radius: 15px;
              background-color: #0d268d;
              color: white;
              border-color: #0d268d;
            "
            >确定
          </van-button>
        </div>
      </van-row>
    </van-popup>
    <!--recharge type 20-->
    <van-popup
      v-model="show"
      :style="{ width: '50%', padding: '10%' }"
      style="max-height: 300px"
    >
      <van-row>
        <div v-html="this.rechargeContent"></div>
      </van-row>
      <van-row>
        <div style="padding-top: 12px">
          <van-button
            type="info"
            size="small"
            @click="closePopup"
            plain
            style="
              width: 40%;
              /* margin-left: 5%; */
              margin-bottom: 5%;
              border-radius: 15px;
              background-color: #f0f0f0;
              color: #0d268d;
              border-color: #f0f0f0;
            "
            >取消
          </van-button>

          <van-button
            type="info"
            size="small"
            @click="submitPopup"
            plain
            style="
              width: 40%;
              margin-left: 16%;
              margin-bottom: 5%;
              border-radius: 15px;
              background-color: #0d268d;
              color: white;
              border-color: #0d268d;
            "
            >确定
          </van-button>
        </div>
      </van-row>
    </van-popup>
    <!--recharge type 21-->
    <van-popup
      v-model="yiyunhuiPopup"
      :style="{ width: '65%', padding: '5%' }"
      style="max-height: 300px"
    >
      <van-row><p style="text-align: center">易云汇支付</p></van-row>
      <van-row>
        <van-col span="6">&nbsp;</van-col>
        <van-col span="12"><div id="qrcode"></div></van-col>
        <van-col span="6">&nbsp;</van-col>
      </van-row>
      <van-row>
        <div style="padding-top: 12px">
          <van-col span="20"
            >易云汇支付 充值地址：<br />
            <p style="font-size: 12px">{{ yiyunpay.link }}</p></van-col
          >
          <van-col span="4">
            <van-button
              plain
              hairline
              native-type="button"
              type="danger"
              size="mini"
              class="right"
              @click="handleCopy(yiyunpay.link)"
              >复制</van-button
            >
          </van-col>
        </div>
      </van-row>
      <van-row>
        <div style="padding-top: 12px">
          <van-col span="24">
            <van-button
              type="info"
              size="small"
              @click="completeRecharge"
              plain
              style="
                border-radius: 15px;
                background-color: #0d268d;
                color: white;
                border-color: #0d268d;
                float: right;
              "
              >我转了钱
            </van-button>
          </van-col>
        </div>
      </van-row>
    </van-popup>
    <van-form @submit="recharge" style="">
      <div id="rechargetop">
        <!-- <van-cell title="当前余额"> -->
        <!-- <template #default>
            <span>{{ cash }}元</span>
          </template> -->
        <!-- </van-cell> -->
        <h5>充值金额</h5>
        <van-field
          v-model="money"
          type="digit"
          name="money"
          label="¥"
          placeholder="请输入充值金额（>100元）"
          style="
            margin-top: -10px;
            margin-bottom: -10px;
            margin-left: 0px;
            background-color: #f0f0f0;
          "
          label-width="30px"
          input-align="left"
          autocomplete="off"
        />
        <h4>余额 {{ cash }} 元</h4>
      </div>

      <van-row class="autofill" v-for="(item, index) in auto_fill_amounts" :key="index">
        <van-col span="6" v-for="(item1, index1) in item" :key="index1">
          <van-button
            class="autofillbtn"
            round
            plain
            hairline
            native-type="button"
            type="danger"
            size="small"
            @click="handleAmount(item1)"
          >
            {{ item1 }}元
          </van-button>
        </van-col>
      </van-row>

      <div style="margin-left: 15px">
        <h4 style="margin-left: 10px">请选择充值类型</h4>
      </div>
      <van-radio-group v-model="radio">
        <van-row
          v-for="(item, index) in rechargeType"
          :key="index"
          clickable
          @click="changeInstructions(index, item.type)"
          class="rechargeTypeBg"
        >
          <van-col span="4">
            <p style="text-align: center; margin: 2px">
              <img style="height: 25px" src="../assets/images/recharge1.png" />
            </p>
          </van-col>
          <van-col span="16">
            <p style="margin: 2px">{{ item.name }}</p>
          </van-col>
          <van-col span="4">
            <p style="margin: 2px"><van-radio :name="index" /></p>
          </van-col>
        </van-row>
      </van-radio-group>
      <van-popup
        v-model="rechargeMaxPopup"
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '15%' }"
      >
        <div>
          <p style="text-align: center; margin-top: 15%">{{ Recharge_Max }}</p>
        </div>
      </van-popup>
      <div class="recharge-notice" v-html="notice_1_1"></div>

      <!--<div class="detail" v-if="radio === '3'">
        <p><span>开户名称:</span> {{ companyBank.name }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.name)">复制</van-button></p>
        <p><span>收款卡号:</span> {{ companyBank.card }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.card)">复制</van-button></p>
        <p><span>收款银行:</span> {{ companyBank.bank }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.bank)">复制</van-button></p>
        <p><span>收款地址:</span> {{ companyBank.address }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.address)">复制</van-button></p>
        <p class="red">银行卡转账后,请联系客服,进行入款操作</p>
      </div>
      <div class="detail" v-if="radio === '1'">
        <p><span>支付宝账号:</span> {{ ali_account }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(ali_account)">复制</van-button></p>
        <p><span>支付宝姓名:</span> {{ ali_accountname }} <van-button plain native-type="button" hairline type="danger" size="mini" class="right" @click="handleCopy(ali_accountname)">复制</van-button></p>
        <p class="red">支付宝转账后,请联系客服,进行入款操作</p>
      </div>-->
      <div id="submitbtn" style="padding-top: 10px">
        <van-button
          block
          type="danger"
          native-type="submit"
          size="small"
          style="height: 50px"
        >
          <span style="font-size: 15px">下一步</span>
        </van-button>
      </div>
      <van-row class="activityRechargeBg">
        <van-col span="24" style="display: flex">
          <van-row class="activityRecha">
            <p class="rechargeActivityTopic">活动专区</p>
            <div class="activitybg">
              <p class="activityListText" @click="onSelect(cachBackId)">
                <span class="numberList">1</span>
                {{ cachBack }}<b>{{ cachBackAmount }}</b
                >{{ cachBackCurrency }}
                <van-icon name="arrow" style="position: absolute; right: 15%" />
              </p>
              <p class="activityListText" @click="onSelect(redPacketesId)">
                <span class="numberList">2</span>
                {{ redPacketes }}
                <van-icon name="arrow" style="position: absolute; right: 15%" />
              </p>
              <p class="activityListText" @click="onSelect(freeVoucherId)">
                <span class="numberList">3</span>
                {{ freeVoucher }}
                <van-icon name="arrow" style="position: absolute; right: 15%" />
              </p>
            </div>
          </van-row>
        </van-col>
      </van-row>
    </van-form>
    <div style="padding: 10px 20px; font-size: 13px" v-html="explain"></div>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { version } from "../../package";
import { Toast } from "vant";
import CommonLoading from "./CommonLoading";
import QRCode from "qrcodejs2";

export default {
  name: "Recharge",
  components: {
    CommonLoading,
  },
  data() {
    return {
      notice_1_1: "",
      notice_2_1: "",
      notice_2_2: "",
      money: "",
      cash: "",
      radio: 0,
      companyBank: {
        name: "",
        card: "",
        bank: "",
        address: "",
      },
      ali_isactive: 0,
      wechat_isactive: 0,
      ali_account: "",
      ali_accountname: "",
      rechargeType: [],
      rechargeMaxPopup: false,
      Recharge_Max: "",
      titles: [],
      explain: "",
      cachBack: "",
      redPacketes: "",
      freeVoucher: "",
      cachBackAmount: "",
      cachBackCurrency: "",
      cachBackId: 0,
      redPacketesId: 0,
      freeVoucherId: 0,
      crypto: {
        money: 0,
        USDTAmount: "",
        qrCode: "",
        endTime: 0,
        rechargeId: 0,
      },
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      qserver_url: "",
      selectedTypeId: "",
      show: false,
      rechargeContent: "",
      auto_fill_amounts: [],
      yiyunpay: {
        qrcode_recharge: "",
        link: "",
      },
      yiyunhuiPopup: false,
      alipayInfo: {},
      showAlipayInfo: false,
    };
  },
  methods: {
    closePopup() {
      this.show = false;
    },
    submitPopup() {
      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "offline_recharge",
          token: sessionStorage.getItem("token"),
          number: this.money,
          type: 20,
          recharge_id: this.selectedTypeId,
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.$toast.fail(res.data.msg);
        } else {
          this.$toast.success(res.data.msg);
          this.$router.push("/member/members");
        }
      });

      this.show = false;
    },
    closeAlipayPopup() {
      this.showAlipayInfo = false;
    },
    submitAlipayPopup() {
      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "offline_recharge",
          token: sessionStorage.getItem("token"),
          number: this.money,
          type: 27,
          recharge_id: this.selectedTypeId,
          card: this.alipayInfo.alipay_account,
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.$toast.fail(res.data.msg);
        } else {
          this.$toast.success(res.data.msg);
          this.$router.push("/member/members");
        }
      });

      this.showAlipayInfo = false;
    },
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    onSelect(type) {
      this.$router.push({
        name: "Activities",
        params: { type: type },
      });
    },
    getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            action: "recharge_activity",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            let config = resData.data.title;
            let explain = resData.data.explain;
            that.explain = explain.replace(/['\n]+/g, "<br>");
            for (let i = 0, len = config.length; i < len; i++) {
              that.titles.push(config[i]);
            }
            that.cachBack = that.titles[0][0];
            that.cachBackAmount = that.titles[0][1];
            that.cachBackCurrency = that.titles[0][2];
            that.cachBackId = that.titles[0][3];
            that.redPacketes = that.titles[1][0];
            that.redPacketesId = that.titles[1][3];
            that.freeVoucher = that.titles[2][0];
            that.freeVoucherId = that.titles[2][3];
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getUser() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.cash = resData.data.cash;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getCompanyBank() {
      let that = this;
      let type = that.rechargeType[that.radio].type;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_info",
            token: sessionStorage.getItem("token"),
            number: that.money,
          },
        })
        .then(function (res) {
          let resData = res.data.data;
          if (res.data.code == 1) {
            that.companyBank = resData.bank;
            that.ali_isactive = Number(resData.ali_isactive);
            that.ali_account = resData.ali_account;
            that.ali_accountname = resData.ali_accountname;

            if (type == 27) {
              that.alipayInfo = res.data.data.alipay;
            }

            /*if (that.ali_isactive === 1){
                  that.ali_account = resData.ali_account;
                }
                that.wechat_isactive = Number(resData.wechat_isactive);
                if (that.wechat_isactive === 1){
                  that.we_chat_pay = resData.we_chat_pay;
                }*/
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$dialog
            .alert({
              title: "线路异常",
              message: "网络状态异常， 请尝试切换线路。",
              confirmButtonText: "切换线路",
            })
            .then(() => {
              that.$router.push({ path: "/api_line_selector" });
            });
        });
    },

    getConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code === 1) {
            if (resData.data.real === null) {
              that.$toast({
                type: "fail",
                message: "还未实名,请前去实名后在充值",
                onClose: function () {
                  that.$router.push("/member/information");
                },
              });
              return false;
            } else {
              that.recharge();
            }
          } else if (resData.code === 0 || resData.code === -1) {
            that.$toast.fail(resData.msg);
            return false;
          }
        });
    },

    recharge_has(money) {
      let that = this;
      if (money <= 0 || isNaN(money)) {
        that.$toast.fail("请输入正确的充值金额");
        return false;
      } else if (money < 100) {
        that.$toast.fail("充值金额必须为大于100元");
        return false;
      }
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "recharge_has",
            token: sessionStorage.getItem("token"),
            number: money,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 0) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.topUpTransit(money);
          } else {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            Dialog.confirm({
              title: "",
              message:
                "您有一笔相同金额的充值成功或失败未能确定，请联系客服，或请使用其他金额充值。",
              cancelButtonText: "确定",
              showConfirmButton: false,
              confirmButtonText: " ",
              cancelButtonClass: "cancelPopup",
            })
              .then(() => {
                that.topUpTransit(money);
              })
              .catch(() => {
                that.$refs.commonLoader.hideCommonLoadigIcon();
              });
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
          that.$dialog
            .alert({
              title: "线路异常",
              message: "网络状态异常， 请尝试切换线路。",
              confirmButtonText: "切换线路",
            })
            .then(() => {
              that.$router.push({ path: "/api_line_selector" });
            });
        });
    },

    recharge() {
      let that = this;
      let money = parseInt(that.money);
      if (money <= 0 || isNaN(money)) {
        that.$toast.fail("请输入正确的充值金额");
        return false;
      } else if (money < 100) {
        that.$toast.fail("充值金额必须为大于100元");
        return false;
      }

      let radio = that.rechargeType[that.radio].type; //parseInt(that.radio);
      console.log(radio);
      switch (radio) {
        case 20:
          this.show = true;
          break;
        case 3:
        case 4:
          //case 8:
          //case 9:
          if (money > 2000000) {
            that.$toast.fail("人工入款金额最大金额为200万");
            return false;
          } else {
            that.recharge_has(money);
          }
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 18:
        case 19:
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 28:
        case 29:
        case 30:
        case 31:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "recharge_max_amount",
                token: sessionStorage.getItem("token"),
                type: radio,
                recharge_id: that.selectedTypeId,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                let maxamountList = res.data.data;
                if (Object.keys(maxamountList).length > 0) {
                  if (money > res.data.data.amount) {
                    (that.rechargeMaxPopup = true),
                      (that.Recharge_Max = res.data.data.message);
                  } else {
                    that.recharge_has(money);
                  }
                } else {
                  that.recharge_has(money);
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              } else {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(() => {
              that.$refs.commonLoader.hideCommonLoadigIcon();
              that.$dialog
                .alert({
                  title: "线路异常",
                  message: "网络状态异常， 请尝试切换线路。",
                  confirmButtonText: "切换线路",
                })
                .then(() => {
                  that.$router.push({ path: "/api_line_selector" });
                });
            });
          // if (money > 50000){
          //   that.$toast.fail('快速入款金额最大金额为5万');
          //   return false;
          // }else{
          //   that.$router.push({path:'/member/recharge/info',query:{type:radio,number:money}})
          // }
          break;
        case 12:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "recharge_max_amount",
                token: sessionStorage.getItem("token"),
                type: radio,
                recharge_id: that.selectedTypeId,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                let maxamountList = res.data.data;
                if (Object.keys(maxamountList).length > 0) {
                  if (money > res.data.data.amount) {
                    (that.rechargeMaxPopup = true),
                      (that.Recharge_Max = res.data.data.message);
                  } else {
                    that.recharge_has(money);
                  }
                } else {
                  that.recharge_has(money);
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              } else {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(() => {
              that.$refs.commonLoader.hideCommonLoadigIcon();
              that.$dialog
                .alert({
                  title: "线路异常",
                  message: "网络状态异常， 请尝试切换线路。",
                  confirmButtonText: "切换线路",
                })
                .then(() => {
                  that.$router.push({ path: "/api_line_selector" });
                });
            });
          break;
        case 27:
          this.getCompanyBank();
          this.showAlipayInfo = true;
          break;
      }

      /*that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "offline_recharge",
              token: sessionStorage.getItem("token"),
              number: money,
              type: that.radio
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                  onClose:function () {
                    that.$router.push('/member/members')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });*/
    },
    topUpTransit(number) {
      let that = this;
      let type = that.rechargeType[that.radio].type; //parseInt(that.radio);
      that.selectedTypeId = that.rechargeType[that.radio].id;
      switch (type) {
        case 3:
        case 4:
          that.$router.push({
            path: "/member/recharge/info",
            query: {
              type: type,
              number: number,
              rechargeTypeId: that.selectedTypeId,
            },
          });
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          that.$router.push({
            path: "/member/recharge/info",
            query: {
              type: type,
              number: number,
              rechargeTypeId: that.selectedTypeId,
            },
          });
          break;
        case 13:
        case 14:
        case 16:
        case 17:
        case 18:
        case 11:
        case 19:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 28:
        case 29:
        case 30:
        case 31:
          // let winRef = window.open("", "_blank");
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "offline_recharge",
                token: sessionStorage.getItem("token"),
                number: number,
                type: type,
                recharge_id: that.selectedTypeId,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                let resData = res.data.data;
                if (resData.url) {
                  if (Capacitor.getPlatform() === "android") {
                    //check if android app, if android app use native plugin to open popup
                    Browser.open({ url: resData.url });
                  } else if (Capacitor.getPlatform() === "ios") {
                    Browser.open({ url: resData.url });
                  } else {
                    // winRef.location = resData.url;
                    Dialog.alert({
                      message: "将在浏览器中打开",
                    }).then(() => {
                      window.open(resData.url, "_blank");
                    });
                  }
                } else {
                  that.$toast.fail(res.data.msg);
                }
              } else if (res.data.code == 2) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(() => {
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
          break;
        case 12:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "offline_recharge",
                token: sessionStorage.getItem("token"),
                number: number,
                type: type,
                recharge_id: that.selectedTypeId,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                let resData = res.data.data;

                that.topUpStatus = true;
                that.disabled4 = false;
                that.crypto.money = resData.orderAmount;
                that.crypto.USDTAmount = resData.orderUSDTAmount;
                that.crypto.qrCode = resData.qrCodeGenerator;
                that.crypto.rechargeId = resData.recharge_id;
                //that.qrcode(that.crypto.qrCode);
                //that.CountDown();

                that.$router.push({
                  path: "/member/recharge/info",
                  query: {
                    type: type,
                    number: that.crypto.money,
                    USDTAmount: that.crypto.USDTAmount,
                    qrCode: that.crypto.qrCode,
                    rechargeId: that.crypto.rechargeId,
                    rechargeTypeId: that.selectedTypeId,
                  },
                });
              } else if (res.data.code == 2) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(() => {
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
          break;
        case 21:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "offline_recharge",
                token: sessionStorage.getItem("token"),
                number: number,
                type: type,
                recharge_id: that.selectedTypeId,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data.data;
                that.yiyunhuiPopup = true;
                that.disabled4 = false;
                that.yiyunpay.qrcode_recharge = resData.url;
                that.yiyunpay.link = resData.url;
                that.qrcode(that.yiyunpay.qrcode_recharge);
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$refs.commonLoader.hideCommonLoadigIcon();
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(() => {
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
          break;
      }
    },
    qrcode(url) {
      setTimeout(function () {
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 100,
          height: 100,
          text: url, // 二维码地址
        });
      }, 0);
    },
    completeRecharge() {
      let that = this;
      that.yiyunhuiPopup = false;
      that.$router.push("/member/members");
    },
    handleAmount(amount) {
      let that = this;
      that.money = amount;
    },
    handleCopy(value) {
      let copy = value;
      let oInput = document.createElement("input");
      oInput.value = copy;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
    getRechargetype() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "account",
            token: sessionStorage.getItem("token"),
            action: "rechargetype",
            app_version: version,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            let rechargeType = resData.data.rechargeType;
            for (let i = 0, len = rechargeType.length; i < len; i++) {
              if (rechargeType[i].isdefault == 1) {
                that.radio = i; //rechargeType[i].type;
              }

              if (rechargeType[i].type == 18) {
                that.rechargeContent = rechargeType[i].recharge_content;
              }
            }
            that.rechargeType = rechargeType;
            // let type = parseInt(that.radio);
            let SelectedType = rechargeType[that.radio]; //rechargeType.find((o) => o.type == type);
            that.notice_1_1 = SelectedType.notice_1_1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
            that.auto_fill_amounts = SelectedType.auto_fill_amounts;
            that.selectedTypeId = SelectedType.id;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$dialog
            .alert({
              title: "线路异常",
              message: "网络状态异常， 请尝试切换线路。",
              confirmButtonText: "切换线路",
            })
            .then(() => {
              that.$router.push({ path: "/api_line_selector" });
            });
        });
    },
    closeRechargeMaxPopup() {
      this.rechargeMaxPopup = false;
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            // that.$toast.fail(res.data.msg);
            that.$refs.commonLoader.hideCommonLoadigIcon();
          }
        })
        .catch(() => {
          // Toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    changeInstructions(index, type) {
      let that = this;
      that.radio = index;
      let SelectedType = that.rechargeType[index];
      that.selectedTypeId = SelectedType.id;
      that.notice_1_1 = SelectedType.notice_1_1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.rechargeContent = SelectedType.recharge_content;
      that.auto_fill_amounts = SelectedType.auto_fill_amounts;
      that.money = "";
    },
  },
  mounted: function () {
    this.get_qchat_server_url();
    this.isLogin();
    this.getRechargetype();
    this.getUser();
    this.getSysConfig();
    // this.getCompanyBank()
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.detail {
  width: 90%;
  margin: 10px auto 0;
}
.detail p {
  font-size: 14px;
}
.detail span {
  font-weight: bold;
}
.right {
  float: right;
}
.detail-img {
  width: 50%;
  margin: 0 auto;
}
.detail-img p {
  font-size: 14px;
  text-align: center;
}
.red {
  color: #d02e27;
}
.chatTextDesign {
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}
#rechargetop {
  margin: 15px 15px 5px 15px !important;
  border: 1px solid #f0f0f0 !important;
  border-radius: 20px !important;
  background-color: #f0f0f0;
  overflow: hidden;
}
#rechargetop h5 {
  margin-top: 12px;
  margin-left: 15px !important;
  font-size: 16px !important;
}
#rechargetop h4 {
  margin-left: 20px !important;
  font-size: 14px !important;
}
.rechargeTypeBg {
  margin: 15px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 15px;
  padding: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.activityRechargeBg {
  background: url("../assets/images/rechargeActivity.png");
  background-size: 100% 100%;
  margin: 30px 15px 0px 15px;
  height: 270px;
}
.activityRecha {
  background-size: 100% 100%;
  width: 84%;
  text-align: center;
  margin: auto;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.rechargeActivityTopic {
  color: #ffac5c;
  text-align: center;
  padding-top: 20px;
  font-size: 20px;
  margin: 0px;
  font-weight: 700;
}
.activitybg {
  padding: 20px;
}
.activityListText {
  margin: 0;
  color: #282828;
  font-size: 13px;
  text-align: left;
  margin-left: 15%;
  padding: 20px 0px 0px;
  display: flex;
  align-items: center;
  position: relative;
}

.numberList {
  color: #de6e43;
  font-size: 16px;
  font-weight: 700;
  padding-right: 5px;
  font-style: italic;
}
.autofill {
  padding-left: 20px;
  padding-top: 10px;
}
.autofillbtn {
  background: linear-gradient(45deg, #ff3b3b, #d02e27) !important;
  color: #ffffff !important;
  border: none !important;
  width: 70px;
  height: 30px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px !important;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}
.recharge-notice {
  padding-left: 20px;
  padding-right: 10px;
  margin: 5px 15px 5px 15px !important;
  background-color: #ffffff;
  border: 1px solid #f0f0f0 !important;
  border-radius: 20px !important;
  overflow: hidden;
}
#submitbtn {
  margin: 5px 15px 5px 15px !important;
}
/deep/ .van-radio__icon--checked .van-icon {
  color: #fff !important;
  background-color: #3f7a21 !important;
  border-color: #3f7a21 !important;
}
/deep/ .van-field__label {
  color: #000000;
}
</style>
<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
.van-dialog__cancelPopup {
  background-color: #409eff !important;
  color: white !important;
  margin: 10px 100px 10px 100px !important;
  height: 30px !important;
}
.van-dialog__cancelPopup :hover {
  color: white !important;
}
#rechargetop .van-field__label {
  font-size: 28px;
  margin-left: 0px;
}
#rechargetop .van-field__control {
  color: #000000 !important;
  text-align: left;
  font-size: 18px;
}
#submitbtn .van-button {
  background-color: #d02e27 !important;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Recharge.vue